export const initialUsersState = {
  users: [],
  usersForClientFilter: [],
  loggedUser: {},
};

export interface IUsersState {
  users: any[],
  usersForClientFilter: any[],
  loggedUser: any
}


